import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import Course from '@/content/models/course.model';
import { LocalStorageService } from '@/services/local-storage.service';
import { PRESENTATION_COURSE_TAB_EVENT, LOCAL_STORAGE_COURSE_ID_PRESENTATION, PRESENTATION_MODE_EVENTS } from '@/content/values/ed-presentation-mode.values';
import EdPresentationModeUserBoardTitle from '@/content/components/ed-presentation-mode/ed-presentation-mode-user-board-title/ed-presentation-mode-user-board-title.component.vue';
import EdPresentationModeMixin from '@/content/mixins/ed-presentation-mode.mixin';
import { UserPositionObserverMixin } from '@/core/mixins/user-position-observer.mixin';
import { EdJitsiMixin } from '@/components/screen-share/ed-screen-share/ed-jitsi-mixin';

@Component({
    components: {
        EdPresentationModeUserBoardTitle,
        EdPresentationModeWebviewOptions: () => import(/* EdPresentationModeWebviewOptions */'../ed-presentation-mode-webview-options/ed-presentation-mode-webview-options.component.vue'),
    }
})
export default class EdPresentationModeHeader extends Mixins(EdPresentationModeMixin, UserPositionObserverMixin, EdJitsiMixin) {

  @Prop() readonly courses: Course[];

  private isLoaded : boolean = false;

  get courseSelected(): number {
    return this.$store.state.CourseStore.presentationCourseSelected;
  }

  get isBoardSectionHomework() : boolean {
    return this.$store.state.CourseStore.isBoardSectionHomework;
  }

  get isTeacherScreenUser() {
    return this.$store.state.MeetingsStore.currentBoardUser.isTeacher;
  }

  get isPresentationTeacherMode() : boolean {
    return this.$store.state.CourseStore.isPresentationTeacherMode;
  }

  get isPresentationStudentMode() : boolean {
    return this.$store.state.CourseStore.isPresentationStudentMode;
  }

  get isWebView() {
    return this.$store.state.AppStore.webview && this.$Auth.Store.isPublisher;
  }

  get hasBoardTitle() {
    if(this.isWebView) {
      return false;
    } else if(this.isWhiteboardTransparency && (this.isTeacherScreenUser || this.isBoardSectionHomework)) {
      return true;
    } else if (this.isShareableTextSection) {
      return true;
    } else {
      return false;
    }
  }

  private loadCourse(course: Course): void {
    if (course) {
      LocalStorageService.setItem(LOCAL_STORAGE_COURSE_ID_PRESENTATION, course.id);
      this.$Courses.Store.updatePresentationCourseSelected({ 
        presentationCourseSelected: course.id 
      });
      this.$edEventBus.$emit(`${PRESENTATION_COURSE_TAB_EVENT}${course.id}`);
      this.notifyUserPosition(course);

      if(!this.isLoaded){
        this.isLoaded = true;
        return;
      }

      this.$nextTick(() => {
        this.$edEventBus.$emit(PRESENTATION_MODE_EVENTS.LOAD_PRESENTATION_ELEMENTS);
      });
    }
  }

  private validateStorageCourse() {
    let storagedCourseId = LocalStorageService.getItem(LOCAL_STORAGE_COURSE_ID_PRESENTATION);
    return storagedCourseId ? this.courses.find(course => course.id === storagedCourseId) : null;
  }

  private notifyUserPosition(course: Course) {
    const classId = this.isPresentationStudentMode ? this.currentPresentationSection?.classId : course?.classId;
    const courseId = this.isPresentationStudentMode ? this.currentPresentationSection?.courseId : course?.id;
    const homeworkId = null;
    const sectionId = this.isPresentationStudentMode ? this.currentPresentationSection?.sectionId : null;
    this.$App.Store.updateUserPosition({sectionId, classId, courseId, homeworkId});
  }

  private startSharingScreen() {
    const params = this.$route.params;
    const meetingId = parseInt(params.meetingId);
    const classId = parseInt(params.classId);

    const shareScreenConfig: any = {username: this.userId, meetingId: meetingId, classId: classId};
    this._connect(shareScreenConfig);
  }

  private stopSharingScreen() {
    this._stopSharingScreen();
  }

  mounted() {
    if (!this.courses) {
      return;
    }

    let storagedCourse = this.validateStorageCourse();
    if (storagedCourse) {
      this.loadCourse(storagedCourse);
    } else {
      this.loadCourse(this.courses[0]);
    }
  }
}